export default __webpack_public_path__ + "static/media/noun-container-ship-1327952.4c25581e.svg";